import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, isRef as _isRef, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04140521"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "MListaDeGrupos",
  "data-testid": "MListaDeGrupos"
}
const _hoisted_2 = { class: "MListaDeGrupos__Cabecalho" }
const _hoisted_3 = { class: "MListaDeGrupos__Titulo" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "pi pi-map" }, null, -1))

import { EntidadeSimples } from "@/types/gerais"
  import AListaDeItens from "../AListaDeItens/AListaDeItens.vue"
  import { computed } from "vue"
  import { useI18n } from "vue-i18n"

  interface Emissoes {
    (event: "update:idItemSelecionado", idGrupo: string): void
  }

  interface Props {
    buscarMaisItens: () => Promise<void>
    itens: EntidadeSimples[]
    idItemSelecionado: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MListaDeGrupos',
  props: {
    buscarMaisItens: null,
    itens: null,
    idItemSelecionado: null
  },
  emits: ["update:idItemSelecionado"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:idItemSelecionado", idGrupo: string): void
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    buscarMaisItens: () => Promise<void>
    itens: EntidadeSimples[]
    idItemSelecionado: string
  }

  
  

  const { t } = useI18n()

  const emitirItemSelecionado = computed({
    get() {
      return props.idItemSelecionado
    },
    set(itemSelecionado: string) {
      emitir("update:idItemSelecionado", itemSelecionado)
    },
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", null, _toDisplayString(_unref(t)('gruposDeProjetos')), 1)
      ])
    ]),
    _createVNode(AListaDeItens, {
      "id-item-selecionado": _unref(emitirItemSelecionado),
      "onUpdate:id-item-selecionado": _cache[0] || (_cache[0] = ($event: any) => (_isRef(emitirItemSelecionado) ? (emitirItemSelecionado).value = $event : null)),
      "buscar-mais-itens": props.buscarMaisItens,
      itens: props.itens
    }, null, 8, ["id-item-selecionado", "buscar-mais-itens", "itens"])
  ]))
}
}

})